import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { Link } from "react-router-dom";
import moment from "moment";
import calendarHandler from "node-ical";
import BookingSmallComponent from "./booking-small-owner-component";
import NotificationComponent from "../inbox/notification-component";
import CalendarComponent from "../../global/calendar-component";
import { initListingData } from "../listing/constants";
import {
  getListingsByOwner,
  publishListing,
  getCalendar,
  setListing,
} from "../listing/actions";
import { getAdminModifiers } from "../../../calendarHelper";
import { getBookings } from "../bookings/actions";
import { getFavoriteListings } from "../../user/actions";
import ReviewAverageComponent from "../../global/review-average-component";
import { getListingImage } from "../../../constants/util";

const mapStateToProps = (state) => ({
  user: state.Dashboard.user,
  booking: state.Booking,
  global: state.Global,
  listingCollection: state.Listing.listingCollection,
  favoriteListings: state.User.favoriteListings,
});

export const handleFile = (response, component, state) => {
  let { calendars } = state;
  let responseLower = response.toLowerCase();
  let type = "other";
  if (responseLower.includes("airbnb")) {
    type = "airbnb";
  } else if (responseLower.includes("homeaway")) {
    type = "vrbo";
  }
  calendarHandler.parseICS(response, function (err, data) {
    let localCalendars = calendars.slice();
    localCalendars.push({ type: type, data: data });
    component.setState({ calendars: localCalendars });
  });
};

export function renderFavoriteListingsMobile(props) {
  let { favoriteListings } = props;
  if (favoriteListings === null || favoriteListings.length === 0)
    return <div className="text-center w-100">No favorite listings found.</div>;

  let activeListings = favoriteListings.listings.filter((x) => x.isActive);

  return (
    <div className="">
      {activeListings.map((l) => {
        if (l._id !== undefined) {
          let url = `/app/#/listing/${l._id}`;
          return (
            <div
              className="favorite-card row justify-content-center"
              key={l._id}
            >
              <a href={url} className="full-width">
                <div className="row">
                  {l.photos.length > 0 && (
                    <div className="col image-container">
                      <div
                        style={{
                          backgroundImage: `url(${getListingImage(l)})`,
                        }}
                      />{" "}
                      {/* ` */}
                    </div>
                  )}
                </div>
                <div className="row image-overlap">
                  <div className="col">
                    <span className="price-bold">${(Math.round(l.pricing.baseFee))}</span>{" "}
                    avg/night
                  </div>
                </div>
                <div className="row">
                  <span className="col-5 marker">
                    <i className="fas fa-map-marker-alt "></i>
                    {l.address.city}, {l.address.state}
                  </span>
                  <div className="col-7">
                    <div className="float-right">
                      <ReviewAverageComponent
                        reviews={l.reviews}
                        averageRating={l.averageRating}
                        starsOnly
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col listing-name-override">
                    {l.listingName}
                  </div>
                </div>
                <div className="row">
                  <div className="col listing-details">
                    <span className="details">{l.houseType}</span> |{" "}
                    {l.bedrooms} {l.bedrooms.count > 1 ? "bedrooms" : "bedroom"}
                  </div>
                </div>
              </a>
            </div>
          );
        } else {
          return <div className="favorite-card-empty col" key={count}></div>;
        }
      })}
    </div>
  );
}

export function renderFavoriteListings(props) {
  let { favoriteListings } = props;
  if (favoriteListings === null || favoriteListings.length === 0)
    return <div className="text-center w-100">No favorite listings found.</div>;

  let activeListings = favoriteListings.listings.filter((x) => x.isActive);

  const rows = Math.ceil(activeListings.length / 2);
  let size = 2;
  let count = 0;

  // this adds a fake card to provide a gap for odd numbers of actual favorite listings
  const length = activeListings.length;
  if ((length / 2) % 1 === 0.5) {
    activeListings.push(1);
  }

  return (
    <div>
      {activeListings.length > 0 ? (
        [...Array(rows)].map((x, i) => {
          return (
            <div className="row justify-content-center" key={i}>
              {activeListings.slice(count, size).map((l) => {
                count++;
                size++;
                if (l._id !== undefined) {
                  let url = `/app/#/listing/${l._id}`;
                  return (
                    <div className="favorite-card col" key={l._id}>
                      <a href={url} className="no-underline">
                        <div className="row">
                          {l.photos.length > 0 && (
                            <div className="col image-container">
                              <div
                                style={{
                                  backgroundImage: `url(${getListingImage(l)})`,
                                }}
                              />{" "}
                              {/* ` */}
                            </div>
                          )}
                        </div>
                        <div className="row image-overlap">
                          <div className="col">
                            <span className="price-bold">
                              ${l.pricing.baseFee}
                            </span>{" "}
                            avg/night
                          </div>
                        </div>
                        <div className="row">
                          <span className="col-5 marker">
                            <i className="fas fa-map-marker-alt"></i>{" "}
                            {l.address.city}, {l.address.state}
                          </span>
                          <div className="col-7">
                            <div className="float-right">
                              <ReviewAverageComponent
                                reviews={l.reviews}
                                averageRating={l.averageRating}
                                starsOnly
                              />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col listing-name-override">
                            {l.listingName}
                          </div>
                        </div>
                        <div className="row">
                          <div className="col listing-details">
                            <span className="details">{l.houseType}</span> |{" "}
                            {l.bedrooms}{" "}
                            {l.bedrooms.count > 1 ? "bedrooms" : "bedroom"}
                          </div>
                        </div>
                      </a>
                    </div>
                  );
                } else {
                  return (
                    <div className="favorite-card-empty col" key={count}></div>
                  );
                }
              })}
            </div>
          );
        })
      ) : (
        <h5>No Favorite Listings</h5>
      )}
    </div>
  );
}

class DashboardComponent extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      numberOfUpcomingBookings: 10,
      currentListing: initListingData,
      calendars: [],
      width: window.innerWidth,
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps !== this.props) {
      let { listingCollection } = this.props;
      if (listingCollection && listingCollection.length > 0) {
        let first =
          typeof this.state.currentListing._id == "undefined"
            ? listingCollection[0]
            : listingCollection.find(
                (x) => x._id === this.state.currentListing._id
              );
        if (
          !prevState.currentListing ||
          (prevState.currentListing &&
            first._id !== prevState.currentListing._id)
        ) {
          this.setState({ currentListing: first, calendars: [] }, () => {
            this.handleCalendarInfo();
          });
        } else {
          this.setState({ currentListing: first });
        }
      }
    }
  }

  componentWillMount() {
    let { dispatch, global } = this.props;
    dispatch(getBookings());
    dispatch(getListingsByOwner(global.userId));
    dispatch(getFavoriteListings(global.userId));
    window.addEventListener("resize", this.handleWindowSizeChange);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleWindowSizeChange);
  }

  compareBookings(a, b) {
    let a_startDate = moment(a.startDate);
    let b_startDate = moment(b.startDate);
    if (b_startDate.isBefore(a_startDate)) return 1;
    else if (b_startDate.isAfter(a_startDate)) return -1;
    else return 0;
  }

  filterBookingsList(bookingsList) {
    return bookingsList
      .filter(
        (b) =>
          moment(b.endDate).isSameOrAfter(moment()) &&
          b.bookingRequestStatus === "Accepted" &&
          b.bookingPaymentStatus !== "Cancelled"
      )
      .sort(this.compareBookings)
      .slice(0, 3);
  }

  goToManageListings = () => {
    let { dispatch } = this.props;
    dispatch(setListing(this.state.currentListing));
  };

  onListingChange = (e) => {
    let { listingCollection } = this.props;
    this.setState(
      {
        currentListing: listingCollection.find((x) => x._id === e.target.value),
        calendars: [],
      },
      () => this.handleCalendarInfo()
    );
  };

  toggleIsActive = () => {
    let { dispatch, global } = this.props;
    let { currentListing } = this.state;
    let message = this.state.currentListing.isActive
      ? "Are you sure you want to unpublish your listing? This will remove it from all areas of the site and not allow bookings."
      : "Are you sure you want to publish your listing? This will allow the listing to be browsed on the site and users can initiate the booking process.";
    if (window.confirm(message)) {
      dispatch(
        publishListing(currentListing._id, !currentListing.isActive)
      ).then(() => {
        dispatch(getListingsByOwner(global.userId));
      });
    }
  };

  handleWindowSizeChange = () => {
    this.setState({ width: window.innerWidth });
  };

  handleCalendarInfo = () => {
    let listingCalendars = this.state.currentListing.calendars
      ? this.state.currentListing.calendars
      : [];
    listingCalendars.forEach((cal) => {
      getCalendar(cal, (response) => handleFile(response, this, this.state));
    });
  };

  renderBookings(bookingsList) {
    return (
      <div className="booking-small-container">
        {bookingsList.length > 0 ? (
          bookingsList.map((b) => (
            <BookingSmallComponent key={b._id} booking={b} />
          ))
        ) : (
          <h5>No Upcoming Bookings</h5>
        )}
      </div>
    );
  }

  renderAvailabilityCalendar(currentListingBookings) {
    let { currentListing, calendars } = this.state;
    let { listingCollection } = this.props;
    return (
      <div className="availability-calendar-container listing-select">
        <div>
          <h2>Availability Calendar</h2>
        </div>
        <hr />
        <div className="row">
          <div className="col">
            <label>
              <select
                onChange={this.onListingChange}
                value={currentListing._id}
              >
                {listingCollection.map((listing, i) => {
                  return (
                    <option key={i} value={listing._id}>
                      {listing.address.address1}
                    </option>
                  );
                })}
              </select>
              <i className="fas fa-angle-down fa-2x"></i>
            </label>
          </div>
          <div className="col text-sm-center">
            <div className="toggle-active">
              <div className="d-inline-flex">
                <strong>Active</strong>
              </div>
              <label className="switch align-top ml-2">
                <input
                  type="checkbox"
                  checked={currentListing.isActive}
                  onChange={this.toggleIsActive}
                />
                <span className="slider round"></span>
              </label>
            </div>
          </div>
          <div className="col-sm text-right">
            <Link
              onClick={this.goToManageListings}
              to="/dashboard/manage-listings?view=ma"
              className="link"
            >
              Manage Availability Calendar
            </Link>
          </div>
        </div>
        {calendars.length === currentListing.calendars.length ? (
          <CalendarComponent
            modifiers={getAdminModifiers(
              currentListing.pricing.overrides,
              calendars,
              currentListingBookings
            )}
            baseFee={currentListing.pricing.baseFee}
            className="display-only"
          />
        ) : (
          <div className="loading-calendar-data">Loading calendar data...</div>
        )}
      </div>
    );
  }

  renderDesktopView(
    hasListings,
    currentListingBookings,
    upcomingListingBookings
  ) {
    return (
      <div>
        <div className="row">
          <div className="col-lg-8">
            <div className="inbox-container mb-3">
              <div>
                <h2>Inbox</h2>
              </div>
              <hr />
              <NotificationComponent type="owner" limit={3} />
              <div className="text-right">
                <Link to="/dashboard/inbox">View All Notifications</Link>
              </div>
            </div>
            {hasListings &&
              this.renderAvailabilityCalendar(currentListingBookings)}
          </div>
          <div className="col-lg-4">
            <div className="bookings-placeholder">
              <div>
                <h2>Upcoming Bookings</h2>
              </div>
              <hr />
              {this.renderBookings(upcomingListingBookings)}
              <div className="text-right">
                <Link to="/dashboard/bookings" className="link">
                  View All Bookings
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-8">
            <div className="favorite-listings-container">
              <div>
                <h2>Favorite Listings</h2>
              </div>
              <hr />
              {renderFavoriteListings(this.props)}
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderMobileView(
    hasListings,
    currentListingBookings,
    upcomingListingBookings
  ) {
    return (
      <div className="row">
        <div className="col-12">
          <div className="inbox-container mb-3">
            <div>
              <h2>Inbox</h2>
            </div>
            <hr />
            <NotificationComponent type="owner" limit={3} />
            <div className="text-right">
              <Link to="/dashboard/inbox">View All Notifications</Link>
            </div>
          </div>
        </div>
        <div className="col-12">
          <div className="bookings-placeholder mb-3">
            <div>
              <h2>Upcoming Bookings</h2>
            </div>
            <hr />
            {this.renderBookings(upcomingListingBookings)}
            <div className="text-right">
              <Link to="/dashboard/bookings" className="link">
                View All Bookings
              </Link>
            </div>
          </div>
        </div>
        <div className="col-12">
          {hasListings &&
            this.renderAvailabilityCalendar(currentListingBookings)}
        </div>
        <div className="col-12">
          <div className="favorite-listings-container">
            <div>
              <h2>Favorite Listings</h2>
            </div>
            <hr />
            {renderFavoriteListingsMobile(this.props)}
          </div>
        </div>
      </div>
    );
  }

  render() {
    let { user, booking, setActive, listingCollection } = this.props;
    let { currentListing, width } = this.state;
    if (!user)
      return (
        <div className="container text-center">
          <h4>Loading...</h4>
        </div>
      );
    let hasListings = !(
      (listingCollection && !listingCollection.length > 0) ||
      !currentListing
    );
    let isMobile = width <= 576;
    let upcomingListingBookings =
      booking && booking.listingBookings
        ? this.filterBookingsList(booking.listingBookings)
        : [];

    let currentListingBookings =
      booking && booking.listingBookings
        ? booking.listingBookings.filter(
            (x) =>
              x.listingId._id === currentListing._id &&
              x.bookingRequestStatus === "Accepted" &&
              x.bookingPaymentStatus !== "Cancelled" &&
              x.bookingPaymentStatus !== "Pending"
          )
        : [];

    return (
      <div className="container dashboard-container">
        <div className="row pl-3 d-flex align-items-baseline">
          <h1>
            Welcome, {user.firstName} {user.lastName.substr(0, 1)}.
          </h1>
          <Link className="profile-link" to={`/profile/${user._id}`}>
            <span>View / Edit Profile</span>
          </Link>{" "}
          {/*` for Chrome debugging */}
        </div>
        <div className="row pl-3 mb-3 dashboard-toggle">
          <a>
            <span onClick={() => setActive("renter")}>
              Switch to Renter Dashboard
            </span>
          </a>
        </div>
        {isMobile
          ? this.renderMobileView(
              hasListings,
              currentListingBookings,
              upcomingListingBookings
            )
          : this.renderDesktopView(
              hasListings,
              currentListingBookings,
              upcomingListingBookings
            )}
      </div>
    );
  }
}

export default withRouter(connect(mapStateToProps)(DashboardComponent));
